export default {
  en : {
    Title : 'Decarbonization',
    Admin: {
      Title : "Admin"
    },
    Report : 'Report',
    ComplexityParameter:  {
      Title: "Energy per tons Moved correlation factors",
      Name : 'Name',
      Constant : 'Constant',
      Exponent : 'Exponent',
      Formula : 'Formula',
      ConfirmDelete : "Do you really want to delete this factor?",
      DeletedConfirmation : "The selected factor was successfully deleted",
      AddNew : 'New parameter',
      Edit : 'Edit parameter'
    },
    EnergySourceUnitConversion:  {
      Title: "Energy source units conversions",
      Name : 'Name',
      ConfirmDelete : "Do you really want to delete this unit conversion?",
      EnergySourceUnitConversionDeleted : "The selected unit conversion was successfully deleted",
      AddNew : 'New conversion',
      Edit : 'Edit conversion',
      EnergySource: 'Energy source',
      GramPerLiter: 'CO2 g/l',
      GJPerCubicMeter: 'GJ/m³'
    },
    EnergySupplyTemplate:  {
      Title: "Energy supply mix templates",
      Name : 'Name',
      ConfirmDelete : "Do you really want to delete this energy supply mix template?",
      DeletedConfirmation : "The selected energy supply mix template was successfully deleted",
      AddNew : 'New template',
      Edit : "Edit template",
      Tab1Title: "Template",
      Tab2Title: "Ratios per year/source",
      Tab2Unavailable: "Ratios per year/source is not available until the template is saved"
    },
    EnergyTypeRatio:  {
      Title: "Energy ratio",
      Rate : 'Rate (%)',
      Year : 'Year',
      StartYear : 'Start year',
      EndYear : 'End year',
      EnergySource : 'Energy source',
      Total : "Total",
      ConfirmDelete : "Do you really want to delete this ratio?",
      DeletedConfirmation : "The selected ratio was successfully deleted",
      BatchAddTitle: "Add yearly ratios",
      AddNew : 'New ratio',
      Edit : "Edit ratio"
    },
    GridEfficiencyTemplate:  {
      Title: "Grid intensity templates",
      Name : 'Name',
      ConfirmDelete : "Do you really want to delete this template?",
      DeletedConfirmation : "The selected template was successfully deleted",
      AddNew : 'New template',
      Edit : "Edit template",
      Tab1Title: "Template",
      Tab2Title: "Emissions rate",
      Tab2Unavailable: "Emissions rate are not available until the template is saved"
    },
    GridEfficiency:  {
      Title: "Emissions rate",
      Rate : 'Rate (kg/kWh)',
      StartYear : 'Start year',
      EndYear : 'End year',
      ConfirmDelete : "Do you really want to delete this rate?",
      DeletedConfirmation : "The selected rate was successfully deleted",
      AddNew : 'New rate',
      Edit : "Edit rate",
      NoRates: "No rates defined"
    },
    EnergySourcesEnum: {
      '0': "Grid Energy",
      '1': "Diesel - Prime Mover",
      '2': "Diesel - Equipment",
      '3': "Gasoline",
      '4': "Natural gas"
    },
    CalculationMethodEnum: {
      '0': "Energy per tons Moved correlation",
      '1': "Manual import of total energy",
      '2': "Manual import of moved tons"
    },
    Publish: {
      SendingRequest : "Sending request...",
      RequestSent : "Request Sent",
      Calculation : "Calculation in progress..."
    },
    EnergyScenarios: {
      Title: "Energy scenarios",
      Edit: "Edit",
      Name: "Name",
      ConfirmDelete : "Do you really want to delete this scenario?",
      DeletedConfirmation : "The selected scenario was successfully deleted",
      Compilation: "Compilation",
      BaseInfoTab: "Base info",
      LOMParametersTab: "LOM Parameters",
      AddNew: "New scenario",
      LOMParametersEditionTab: "Configuration",
      LOMParametersToCreate: "Parameters to define",
      LOMName: "Entity",
      LOMParametersCreated: "Parameters created",
      EnergySupplyTemplate: "Energy supply mix template",
      GridEfficiencyTemplate: "Electricity carbon intensity",
      ComplexityParameter: "Correlation factor",
      CalculationMethod: "Calculation method",
      EnergySimulation: "Projected energy consumption",
      Year: "Year",
      EnergyConsumption: "GJ Consummed by Project",
      Tonnage: "Tonnes moved",
      ComplexityFactor: "Complexity factor",
      EnergyDemand: "Energy demand (GJ)",
      KWhEquivalent: "kWh Equivalent (hr)",
      MwEquivalent: "MW Equivalent (hr)",
      LitersEquivalent: "Liters Equivalent",
      CO2Factor: "CO² - factors",
      CO2Equivalent: "CO²",
      AllParametersDefined : "All parameters are already defined",
      EmptyParametersDefined : "No parameter defined yet",
      UploadTemplateTotalEnergyFile : 'Get the total energy template file',
      UploadTemplateMovedTonsFile : 'Get the moved tons template file',
      UploadWarning : "Uploading a LOM parameter Energy Demand file will override any existing energy demands",
      UploadFile : "Upload LOM parameter Energy Demand file",
      UploadInvalidFileError : "Invalid upload file",
      ParameterMustBeCreated : "The LOM parameter must be saved before uploading an entry file",
      UploadSuccess : "The LOM parameter Energy Demand file has been successfully processed",
      UploadFails : "Upload failure",
      UploadFailText : "The upload file has an unsupported schema.  Please download the latest available template and try again"
    }
  }
}
